"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : CTA : SOCIAL : STYLES --------------- ++++++++++ */


var _default = {
  social: {
    '& .message': {
      fontWeight: '600',
      marginBottom: (0, _index.pxToEm)(15)
    },
    '& .link': {
      borderRadius: '100%',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      width: (0, _index.pxToEm)(50),
      height: (0, _index.pxToEm)(50),
      marginRight: (0, _index.pxToEm)(16),
      '&:last-child': {
        marginRight: '0'
      },
      '& .icon': {
        color: _index.theme.color.light.light.swatch,
        fontSize: (0, _index.pxToEm)(22)
      },
      // types
      '&.name-facebook': {
        background: "#3B5999"
      },
      '&.name-twitter': {
        background: "#55ACEE"
      },
      '&.name-linkedin': {
        background: "#0077B5"
      }
    }
  }
};
exports.default = _default;